import React, { lazy, Suspense } from 'react';

import { useParams } from 'react-router-dom';

import PageWrapper from 'components/PageWrapper';
import { workspacePages } from 'utils/constants';

// Lazy load components
const WorkspaceInfoPage = lazy(() => import('../WorkspaceInfoPage/Loadable'));
const WorkspaceTemplatesPage = lazy(() => import('../WorkspaceTemplatesPage/Loadable'));
const WorkspaceMembersPage = lazy(() => import('../WorkspaceMembersPage/Loadable'));
const OrganizationDashboardPage = lazy(() => import('../OrganizationDashboardPage/Loadable'));
const FormPage = lazy(() => import('../FormPage/Loadable'));

function WorkspacePage() {
  const { pageName } = useParams();

  const layoutByPageName = {
    [workspacePages.info]: <WorkspaceInfoPage />,
    [workspacePages.templates]: <WorkspaceTemplatesPage />,
    [workspacePages.members]: <WorkspaceMembersPage />,
    [workspacePages.dashboard]: <OrganizationDashboardPage />,
    [workspacePages.form]: <FormPage />,
  };

  return (
    <Suspense fallback="">
      <PageWrapper>{layoutByPageName[pageName]}</PageWrapper>
    </Suspense>
  );
}

export default WorkspacePage;
